import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=badabc62&scoped=true"
import script from "./CheckboxView.vue?vue&type=script&lang=js"
export * from "./CheckboxView.vue?vue&type=script&lang=js"
import style0 from "./CheckboxView.vue?vue&type=style&index=0&id=badabc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badabc62",
  null
  
)

export default component.exports